import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { nav("/"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          await refresh();
        } else if (tries++ < 20) {
          setTimeout(poll, 1500);
        } else {
          setStatus("timeout");
        }
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId, nav, refresh]);

  return (
    <div data-testid="payment-success" className="grid-bg min-h-[85vh] flex items-center justify-center px-4 py-16">
      <div className="brutal-card brutal-shadow max-w-md text-center" style={{borderColor:'#CCFF00'}}>
        {status === "checking" && (
          <>
            <div className="font-bebas text-4xl tracking-tighter">Confirmando o pagamento...</div>
            <p className="mt-3 text-white/60 font-manrope">Segura aí, cria. Tá quase.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="mx-auto text-[#CCFF00]" size={64}/>
            <div className="font-bebas text-5xl mt-4 tracking-tighter">AÍ SIM, CRIA!</div>
            <p className="mt-3 text-white/70 font-manrope">Assinatura ativa. Todos os cursos + Coach AI liberados.</p>
            <Link to="/dashboard" data-testid="success-to-dashboard" className="brutal-btn mt-8 w-full">Ir pro Dashboard</Link>
          </>
        )}
        {(status === "timeout" || status === "error") && (
          <>
            <div className="font-bebas text-4xl tracking-tighter">Ops, tá demorando</div>
            <p className="mt-3 text-white/60 font-manrope">Se a grana foi debitada, atualiza a página em uns minutos.</p>
            <Link to="/dashboard" className="brutal-btn mt-6 w-full">Dashboard</Link>
          </>
        )}
      </div>
    </div>
  );
}
